import httpClient from "@hd/http-client/http-client";
import { CommunicationEntityDomain } from "@hd/types/dto/communication/communication-entity-domain";
import { CommunicationToSendDto } from "@hd/types/dto/communication/communication-to-send.dto";
import { useMutation } from "@tanstack/react-query";

type Params = {
  groupId: number | null; // mandatory
  companyId: number | null;
  contactId: number | null; // mandatory

  entityDomain: CommunicationEntityDomain; // quotation, request, etc..
  entityId: string;

  actionCode: string | null;
  sendCommunications: CommunicationToSendDto[];
};

const request = async (data: Params) => {
  const result = await httpClient.post<boolean>(
    import.meta.env.VITE_HD_API_URL +
      `/${data.entityDomain}/${data.entityId}/workflow-action`,
    {
      ...data,
    },
  );
  return result.data;
};

export const useSendCommunicationMutation = () => {
  return useMutation({
    mutationFn: (data: Params) => request(data),
  });
};
